import React, { useState, useEffect } from 'react';
import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { chatbotApi } from '../../../common/src';
import axios from 'axios';

const WidgetChannel = (props) => {
  const [city, setCity] = useState(1);
  const [list, setList] = useState();
  const param = props.childProps.payload.param;
  const preText = props.childProps.state.prevMessage;
  // //console.log(param);
  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _onChange = (e) => {
    setCity(e.target.value);
  };
  const _getData = async () => {
    const result = await axios.get(chatbotApi + '/api/getChannel?city=' + city);
    const intReturn = result.data.intReturn;
    if (intReturn === 0) {
      setList(result.data.listData);
      //   //console.log(result.data.listData);
    }
  };
  useEffect(() => {
    _getData();
  }, [city]);
  return (
    <>
      <div className="channel-info-wrapper">
        <div className="channel-header">{param} 채널 안내</div>
        {param === '지역별 케이블 TV' && (
          <div className="select-wrapper">
            <select className="custom-select" value={city} onChange={_onChange}>
              <option value={1}>서울특별시 v</option>
              <option value={2}>강원도</option>
              <option value={3}>경기도</option>
              <option value={4}>경상도</option>
              <option value={5}>대구광역시</option>
              <option value={6}>대전광역시</option>
              <option value={7}>부산광역시</option>
              <option value={12}>울산광역시</option>
              <option value={8}>인천광역시</option>
              <option value={9}>전라도</option>
              <option value={13}>광주광역시</option>
              <option value={10}>제주도</option>
              <option value={11}>충청도</option>
            </select>
          </div>
        )}

        <div className="channel-table-wrapper">
          <table className="channel-table">
            <thead>
              <tr>
                <th>서비스 지역</th>
                <th>방송사명</th>
                <th>고객센터</th>
                <th>채널번호</th>
              </tr>
            </thead>
            {param === '위성/IP TV' ? (
              <tbody>
                <tr>
                  <td>전국</td>
                  <td>SKYLIVE</td>
                  <td>1588-3002</td>
                  <td>CH.484</td>
                </tr>
                <tr>
                  <td>전국</td>
                  <td>Genie TV</td>
                  <td>국번없이 100</td>
                  <td>CH.990</td>
                </tr>
                <tr>
                  <td>전국</td>
                  <td>LG U+</td>
                  <td>국번없이 101</td>
                  <td>CH.328</td>
                </tr>
                <tr>
                  <td>전국</td>
                  <td>SK</td>
                  <td>국번없이 106</td>
                  <td>CH.176</td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {list &&
                  list.map((item) => (
                    <tr key={item.channelCode}>
                      <td>{item.location}</td>
                      <td>{item.name}</td>
                      <td>{item.etc}</td>
                      <td>{item.channelNumber}</td>
                    </tr>
                  ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText && (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};
export default shopContext(withRouter(WidgetChannel));
